import React from "react";
import Button from "../../components/ui/Button";
import { useTranslation } from "react-i18next";

const ProductManagement = ({ featuredProducts }) => {

  const {t, i18n} = useTranslation();
  const topProducts = [
    {
      id: 1,
      name: "Apple iPhone 13",
      item: "#FXZ-4567",
      price: "$999.00",
      image: "/images/img_image_270.png",
      bgImage: "/images/img_.png",
    },
    {
      id: 2,
      name: "Nike Air Jordan",
      item: "#FXZ-4567",
      price: "$72.40",
      image: "/images/img_frame_48.png",
    },
    {
      id: 3,
      name: "T-shirt",
      item: "#FXZ-4567",
      price: "$35.40",
      image: "/images/img_image_269.png",
      bgImage: "/images/img_0x0.png",
    },
    {
      id: 4,
      name: "Assorted Cross Bag",
      item: "#FXZ-4567",
      price: "$80.00",
      image: "/images/img_frame_51.png",
    },
    {
      id: 5,
      name: "Fur Pom Gloves",
      item: "#FXZ-4567",
      price: "$20.00",
      image: "/images/img_frame_48_56x56.png",
    },
  ];

  const bestSellingProducts = [
    {
      id: 1,
      name: "Apple iPhone 13",
      orders: 104,
      status: "Stock",
      price: "$999.00",
      image: "/images/img_image_270_46x46.png",
      statusColor: "#21c45d",
    },
    {
      id: 2,
      name: "Nike Air Jordan",
      orders: 56,
      status: "Stock out",
      price: "$999.00",
      image: "/images/img_frame_48.png",
      statusColor: "#ef4343",
    },
    {
      id: 3,
      name: "T-shirt",
      orders: 266,
      status: "Stock",
      price: "$999.00",
      image: "/images/img_frame_51_46x46.png",
      statusColor: "#21c45d",
    },
    {
      id: 4,
      name: "Cross Bag",
      orders: 506,
      status: "Stock",
      price: "$999.00",
      image: "/images/img_frame_51_1.png",
      statusColor: "#21c45d",
    },
  ];

  const categories = [
    { name: "Electronic", image: "/images/img_image_271.png" },
    { name: "Fashion", image: "/images/img_image.png" },
    { name: "Home", image: "/images/img_image_46x46.png" },
  ];

  const newProducts = [
    {
      name: "Smart Fitness Tracker",
      price: "$39.99",
      image: "/images/img_image_34x46.png",
    },
    {
      name: "Leather Wallet",
      price: "$19.99",
      image: "/images/img_image_1.png",
    },
    {
      name: "Electric Hair Trimmer",
      price: "$34.99",
      image: "/images/img_image_2.png",
    },
  ];

  return (
    <div className="flex flex-col gap-5 w-full lg:w-[30%]">
      {/* Top Products */}
      <div className="flex flex-col bg-background-card rounded-base shadow-[0px_1px_3px_#00000033] p-4">
        <div className="flex flex-col gap-3 mb-6 mt-5">
          <div className="flex justify-between items-center">
            <h3 className="text-lg font-bold text-text-accent">{t("featured_products")}</h3>
        
          </div>

      
        </div>

        <div className="flex flex-col gap-4">
          {featuredProducts?.map((product) => (
            <div
              key={product?.id}
              className="flex items-start gap-4 pb-4 border-b border-border-secondary last:border-b-0"
            >
              <div className="relative w-14 h-14 rounded-xl overflow-hidden">
                {product?.images?.length > 0 && (
                  <img
                    src={product?.images[0]?.file_path}
                    alt=""
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                )}
                <img
                  ssrc={product?.images[0]?.file_path}
                  alt={product?.name}
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="flex flex-col gap-1 flex-1 mt-1">
                <span className="text-[15px] font-medium text-text-accent">
                  {i18n.language === "en"
                    ? product?.translations?.en?.name
                    : product?.translations?.ar?.name}
                </span>
                <span className="text-sm text-text-muted">

                        {i18n.language === "en"
                    ? product?.category?.translations?.en?.name
                    : product?.category?.translations?.ar?.name}
                </span>
              </div>

              <span className="text-[15px] font-bold text-text-accent mt-4">
                  {product?.price_after_discount !== null
                ? product?.price_after_discount
                : product?.price}
               
              </span>
            </div>
          ))}
        </div>
      </div>
      {/* Best Selling Products & Add New Product 
      <div className="flex flex-col gap-5">
        
        <div className="flex flex-col bg-background-card rounded-base shadow-[0px_1px_3px_#00000033] p-5">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-bold text-text-accent">
              Best selling product
            </h3>

            <div className="flex items-center gap-2 bg-success-background rounded-base px-3 py-1.5">
              <span className="text-base text-white">Filter</span>
              <img
                src="/images/img_sort.svg"
                alt="Filter"
                className="w-5 h-5"
              />
            </div>
          </div>

     
          <div className="flex items-center bg-success-light rounded-base p-3.5 mb-1">
            <span className="text-sm font-medium text-text-secondary uppercase pl-5 flex-1">
              Product
            </span>
            <div className="flex items-center flex-1">
              <span className="text-sm font-medium text-text-secondary uppercase">
                Total Order
              </span>
              <span className="text-sm font-medium text-text-secondary uppercase ml-16">
                Status
              </span>
            </div>
            <span className="text-sm font-medium text-text-secondary uppercase">
              Price
            </span>
          </div>

  
          <div className="flex flex-col gap-1">
            {bestSellingProducts?.map((product) => (
              <div key={product?.id} className="flex items-center py-3">
                <div className="flex items-start gap-3 flex-1">
                  <img
                    src={product?.image}
                    alt={product?.name}
                    className="w-12 h-12 rounded-xl"
                  />
                  <span className="text-[15px] font-bold text-text-accent mt-3.5">
                    {product?.name}
                  </span>
                </div>

                <div className="flex items-start flex-1">
                  <span className="text-[15px] text-text-accent mt-3">
                    {product?.orders}
                  </span>
                  <div className="flex items-start gap-2 bg-white rounded px-5 py-3 ml-4 mr-4.5">
                    <div
                      className="w-2 h-2 rounded-full mt-1.5"
                      style={{ backgroundColor: product?.statusColor }}
                    ></div>
                    <span
                      className="text-[15px] mb-2"
                      style={{ color: product?.statusColor }}
                    >
                      {product?.status}
                    </span>
                  </div>
                </div>

                <span className="text-[15px] font-bold text-text-accent">
                  {product?.price}
                </span>
              </div>
            ))}
          </div>

          <Button
            text="Details"
            text_font_size="16"
            text_color="#6467f2"
            fill_background_color="transparent"
            border_border_radius="16px"
            className="border border-primary-background mt-4"
            padding="4px 24px"
            effect_box_shadow=""
            fill_background=""
            border_border=""
            border_border_image=""
            layout_align_self=""
            layout_width=""
            margin=""
            position=""
            layout_gap=""
            variant=""
            size=""
            onClick={() => {}}
          />
        </div>

      
        <div className="flex flex-col bg-background-card rounded-base shadow-[0px_1px_3px_#00000033] p-4.5 ml-2.5">
          <div className="flex justify-between items-center mb-2">
            <h3 className="text-lg font-bold text-text-accent">
              Add New Product
            </h3>
            <div className="flex items-center gap-1">
              <img
                src="/images/img_add_square_04.svg"
                alt="Add"
                className="w-5 h-5"
              />
              <span className="text-base text-primary-background">Add New</span>
            </div>
          </div>

          <span className="text-base text-text-secondary mb-4">Categories</span>

          <div className="flex flex-col gap-3 mb-4">
            {categories?.map((category, index) => (
              <div
                key={index}
                className="flex items-center justify-between bg-white shadow-[0px_1px_3px_#00000033] rounded-sm p-1.5"
              >
                <div className="flex items-center gap-3">
                  <div className="border border-border-primary rounded p-1.5">
                    <img
                      src={category?.image}
                      alt={category?.name}
                      className="w-12 h-8"
                    />
                  </div>
                  <span className="text-lg text-text-primary">
                    {category?.name}
                  </span>
                </div>
                <img
                  src="/images/img_chevron_right.svg"
                  alt="Arrow"
                  className="w-5 h-5"
                />
              </div>
            ))}
          </div>

          <div className="flex flex-col gap-3">
            <span className="text-base text-primary-background self-center">
              See more
            </span>
            <span className="text-base text-text-secondary self-start">
              Product
            </span>

            <div className="flex flex-col gap-2.5">
              {newProducts?.map((product, index) => (
                <div key={index}>
                  <div className="flex justify-between items-start">
                    <div className="border border-border-primary rounded p-1">
                      <img
                        src={product?.image}
                        alt={product?.name}
                        className="w-12 h-8"
                      />
                    </div>

                    <div className="flex items-center flex-1 ml-3">
                      <div className="flex flex-col gap-1.5 flex-1">
                        <span className="text-base text-text-primary">
                          {product?.name}
                        </span>
                        <span className="text-base font-bold text-success-background">
                          {product?.price}
                        </span>
                      </div>

                      <Button
                        text="Add"
                        text_font_size="12"
                        text_color="#ffffff"
                        fill_background_color="#053c21"
                        border_border_radius="14px"
                        className="flex items-center gap-1 self-end"
                        padding="4px 12px 4px 28px"
                        effect_box_shadow=""
                        fill_background=""
                        border_border=""
                        border_border_image=""
                        layout_align_self=""
                        layout_width=""
                        margin=""
                        position=""
                        layout_gap=""
                        variant=""
                        size=""
                        onClick={() => {}}
                      >
                        <img
                          src="/images/img_addsquare04_white_a700.svg"
                          alt="Add"
                          className="w-4 h-4"
                        />
                        <span>Add</span>
                      </Button>
                    </div>
                  </div>

                  {index < newProducts?.length - 1 && (
                    <div className="w-full h-px bg-border-primary mt-2.5"></div>
                  )}
                </div>
              ))}
            </div>

            <span className="text-base text-primary-background self-center mt-3">
              See more
            </span>
          </div>
        </div>
      </div>*/}
    </div>
  );
};

export default ProductManagement;
